/*
 * @Author: wangbaihe
 * @Date: 2023-12-08 16:26:31
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-10-22 15:52:56
 * @FilePath: \common-mediax\src\apis\MediaCloudPaper\ArticleEdit.js
 * @Description: MediaCloudPaperArticleEdit
 */
import { createAPI } from '@common'

//这里的接口和报纸小样编辑稿件或公共组件接口相关 MediaCloudPaperArticleEdit
export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60bdujpot0efubjmbdujpot', 'get', config),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmf0feju0joju', 'get', config),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmf0feju0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0qbqfst0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到全媒体采编发
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 提交审核
  postFinalSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0tvcnju0bveju', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 判断报纸类型是否是手动回退 返回true代表是
  getNeedManualrollback: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0qbhft0bdujpot0mbzpvu0offenbovbmspmmcbdl',
      'get',
      config,
      vconfig
    ),
  // 退稿接口
  postArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmft0bdujpot0sfwplf', 'post', config),
  // 获取稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmf0feju0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0bsujdmf0feju0efubjm', 'get', config),
  // 获取拥有图片制作人员的名单（全媒体采编发提供的接口）
  getNewsEditPicmakeUsersNew: (config) =>
    //原接口: /mediax-open/sign/picmake/users
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0qjdnblf0qbqfs0vtfst', 'get', config, {
      neverLoading: true
    }),
  //  读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewsEditUserPapers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0mjtuebub', 'get', config),
  getNewsEditUserPapersColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0dpmvnot', 'get', config),
  // 给定一个栏目，获取版次
  getNewsEditUserPapersLayouts: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjho0mbzpvut', 'get', config),
  // 报纸采编读当前用户可访问的报纸列表（全媒体采编发提供的接口）
  getNewsEditUserPapersPaperEdit: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.pqfo0nfejby.qbqfs0tjho0mjtuebub',
      'get',
      config,
      vconfig
    ),
  // 文章是否包含图片
  postNewseditAttachmentsCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0buubdinfout0difdl', 'post', config),
  // 获取报纸大样版面
  getPaperBigStyleList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0f60mjtuebub', 'POST', config),
  // 小样重稿-获取图片稿件相似稿列表
  getSimilarList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.qbqfs0tjnjmbs0mjtuebub', 'get', config)
}
